/**
 * Creates a new Web Worker instance with the provided code.
 * @returns {Worker} - The created Web Worker instance.
 */
export const createWorker = (): Worker => {
  const workerCode = `
    self.addEventListener('message', function(e) {
      const { data } = e;
      try {
        // Support string-wrapped payloads to avoid structured clone failures
        let raw = data;
        if (raw && typeof raw === 'object' && Object.prototype.hasOwnProperty.call(raw, '__json')) {
          raw = raw.__json;
        }

        let processedData;
        if (typeof raw === 'string') {
          // If we received a pre-serialized string, parse it directly
          processedData = JSON.parse(raw);
        } else {
          // Otherwise, attempt to serialize/deserialize to strip non-serializables
          processedData = JSON.parse(JSON.stringify(raw));
        }

        postMessage({ success: true, data: processedData });
      } catch (error) {
        postMessage({ success: false, error: error.message });
      }
    });
  `;

  const blob = new Blob([workerCode], { type: 'application/javascript' });
  return new Worker(URL.createObjectURL(blob));
};
